import React from 'react';
import { Button } from '@mui/material';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import SkeletonLoader from '../../loader/SkeletonLoader';
import { getLoaderStatus } from '../../loader/loaderSelector';


const FormButton = ({
    title,
    className,
    id,
    variant,
    handleClick,
    type,
    isLoading,
    ariaLabel,
    buttonRef
}) => (
    <SkeletonLoader
        isLoading={isLoading}
        skeletonProps={{
            animation: 'wave',
            variant: 'rectangular',
            className: 'skeletonclass form-button-generic',
            height: 36
        }}
    >
        <Button
            className={classNames('form-button-container', className, {
                'custom-form-primary-button': variant === 'primary',
                'custom-form-secondary-button': variant === 'secondary'
            })}
            id={id}
            type={type}
            onClick={handleClick}
            disableRipple={variant === 'secondary'}
            aria-label={ariaLabel}
            ref={buttonRef}
        >
            {title}
        </Button>
    </SkeletonLoader>
);

FormButton.defaultProps = {
    className: '',
    id: '',
    variant: '',
    handleClick: null,
    type: 'button',
    ariaLabel: '',
    buttonRef: undefined
};

FormButton.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]).isRequired,
    variant: PropTypes.oneOf(['primary', 'secondary', '']),
    handleClick: PropTypes.func,
    type: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
    ariaLabel: PropTypes.string,
    buttonRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};

const mapStateToProps = state => ({
    isLoading: getLoaderStatus(state)
});

export default connect(mapStateToProps)(injectIntl(FormButton));
